import { blobToDataURL } from "@/utils/utils";
import { RootState } from "..";
import { GenParams } from "./GenParams";

export const buildEsrganParam = async (state: RootState): Promise<GenParams> => {
  const upscalingLevel = 2 | 4;
  const upscalingStrength = 0.2;
  const upscalingDenoising = 0.3;

  var response = await fetch("");
  var blob = await response.blob();
  var base64Img = await blobToDataURL(blob);
  const graph: GenParams = {
    type: "esrgan",
    init_image: base64Img,
    prompt: "",
    negative_prompt: "",
    generateType: "",
    n_iter: 1,
    width: 0,
    height: 0,
    style: "",
    refStructure: "",
    refStyle: "",
    baseImage: "",
    maskImage: "",
    upscaler: upscalingLevel,
    upscalingStrength: upscalingStrength,
    upscalingDenoising: upscalingDenoising,
    seed:0,
    steps:30
  };

  return graph;
};
